import styled, { css } from 'styled-components';

interface ImageProps {
  readonly $isActive?: boolean;
}

export const FeatureWrapper = styled.div``;

export const CarouselList = styled.ul`
  display: flex;
  list-style: none;
  transition: transform 0.5s ease;
`;

export const CardItem = styled.li`
  margin: 35px;

  &:first-child {
    margin-left: 0;
  }

  &:not(:last-child) {
    margin-right: 35px;
  }

  @media screen and (max-width: 900px) {
    margin-bottom: 24px;
  }
`;

export const CardImage = styled.img<ImageProps>`
  max-width: 230px;
  object-fit: contain;

  ${({ $isActive }) =>
    $isActive &&
    css`
      border: 3px solid rgba(51, 147, 236, 1);
      border-radius: 23.56px;
    `}
  @media screen and (max-width: 900px) {
    max-width: 157px;
    border: 1px solid rgba(51, 147, 236, 1);
    border-radius: 23.56px;
  }
`;

export const ButtonsWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  margin-top: 32px;

  @media screen and (max-width: 900px) {
    display: none;
  }
`;

export const ArrowButton = styled.button`
  outline: none;
  border: none;
  background: transparent;

  img {
    width: 77px;
  }

  &:hover {
    cursor: pointer;
    opacity: 0.9;

    &:disabled {
      cursor: default;
      opacity: 1;
    }
  }
`;

export const Counter = styled.p`
  font-weight: 400;
  font-size: 16px;
  line-height: 21px;
  color: rgba(50, 50, 50, 1);
  margin: 0 24px;
`;
